module.exports = __webpack_public_path__ + "img/syukyaku-gyoumu-001sp.71b7c23a.jpg";